import * as gConst from 'services/constants';

const FILTER_STATUS_ARRAY = [
  // 0 booked
  {
    index: 0,
    translateLabel: 'consultation_booked',
    conditions: [gConst.STATUS_BOOKED],
    defaultActive: true
  },
  // 1 canceled
  {
    index: 1,
    translateLabel: 'consultation_canceled',
    conditions: [gConst.STATUS_CANCELLED],
    defaultActive: false,
    bottomLine: true
  },
  // 2 arrived
  {
    index: 2,
    translateLabel: 'arrived',
    conditions: [gConst.STATUS_ARRIVED, gConst.STATUS_SELF_ARRIVED],
    defaultActive: true
  },
  // 3 consultation_in_progress
  {
    index: 3,
    translateLabel: 'consultation_in_progress',
    conditions: [
      gConst.STATUS_STARTED,
      gConst.STATUS_CONSULTATION_RESTARTED,
      gConst.STATUS_SUSPENDED,
      gConst.STATUS_CONSULTATION_STARTED_AFTER_RADIOLOGY
    ],
    defaultActive: true
  },
  // 4 to radiology
  {
    index: 4,
    translateLabel: 'to_radiology',
    conditions: [
      gConst.STATUS_RADIOLOGY_STARTED,
      gConst.STATUS_RADIOLOGY_STARTED_DURING
    ],
    defaultActive: true
  },
  // 5 from radiology
  {
    index: 5,
    translateLabel: 'from_radiology',
    conditions: [
      gConst.STATUS_RADIOLOGY_FINISHED,
      gConst.STATUS_RADIOLOGY_FINISHED_DURING
    ],
    defaultActive: true
  },
  // 6 finished
  {
    index: 6,
    translateLabel: 'consultation_finished',
    conditions: [gConst.STATUS_FINISHED],
    defaultActive: true,
    bottomLine: true
  },
  // 7 paid
  {
    index: 7,
    translateLabel: 'consultation_paid',
    conditions: [gConst.STATUS_PAID],
    defaultActive: true
  },
  // 8 not show
  {
    index: 8,
    translateLabel: 'consultation_nowshow',
    conditions: [gConst.STATUS_NO_SHOW],
    defaultActive: false
  }
];

const FILTER_STATUS_ARRAY_RADIOLOGY = [
  // 2 arrived
  {
    index: 2,
    translateLabel: 'arrived',
    conditions: [gConst.STATUS_ARRIVED, gConst.STATUS_SELF_ARRIVED],
    defaultActive: true
  },
  // 3 consultation_in_progress
  {
    index: 3,
    translateLabel: 'consultation_in_progress',
    conditions: [
      gConst.STATUS_STARTED,
      gConst.STATUS_CONSULTATION_RESTARTED,
      gConst.STATUS_SUSPENDED,
      gConst.STATUS_CONSULTATION_STARTED_AFTER_RADIOLOGY
    ],
    defaultActive: true
  },
  // 4 to radiology
  {
    index: 4,
    translateLabel: 'to_radiology',
    conditions: [
      gConst.STATUS_RADIOLOGY_STARTED,
      gConst.STATUS_RADIOLOGY_STARTED_DURING
    ],
    defaultActive: true
  },
  // 5 from radiology
  {
    index: 5,
    translateLabel: 'from_radiology',
    conditions: [
      gConst.STATUS_RADIOLOGY_FINISHED,
      gConst.STATUS_RADIOLOGY_FINISHED_DURING
    ],
    defaultActive: true
  },
];

const FILTER_STATUS_ARRAY_CREATE_NEW_JOB = [
  // 0 booked
  {
    index: 0,
    translateLabel: 'consultation_booked',
    conditions: [gConst.STATUS_BOOKED],
    defaultActive: true
  },
  // 1 canceled
  {
    index: 1,
    translateLabel: 'consultation_canceled',
    conditions: [gConst.STATUS_CANCELLED],
    defaultActive: false,
    bottomLine: true
  },
  // 2 arrived
  {
    index: 2,
    translateLabel: 'arrived',
    conditions: [gConst.STATUS_ARRIVED, gConst.STATUS_SELF_ARRIVED],
    defaultActive: true
  },
  // 3 consultation_in_progress
  {
    index: 3,
    translateLabel: 'consultation_in_progress',
    conditions: [
      gConst.STATUS_STARTED,
      gConst.STATUS_CONSULTATION_RESTARTED,
      gConst.STATUS_SUSPENDED,
      gConst.STATUS_CONSULTATION_STARTED_AFTER_RADIOLOGY
    ],
    defaultActive: true
  },
  // 4 to radiology
  {
    index: 4,
    translateLabel: 'to_radiology',
    conditions: [
      gConst.STATUS_RADIOLOGY_STARTED,
      gConst.STATUS_RADIOLOGY_STARTED_DURING
    ],
    defaultActive: true
  },
  // 5 from radiology
  {
    index: 5,
    translateLabel: 'from_radiology',
    conditions: [
      gConst.STATUS_RADIOLOGY_FINISHED,
      gConst.STATUS_RADIOLOGY_FINISHED_DURING
    ],
    defaultActive: true
  },
  // 6 finished
  {
    index: 6,
    translateLabel: 'consultation_finished',
    conditions: [gConst.STATUS_FINISHED],
    defaultActive: true,
    bottomLine: true
  },
  // 7 paid
  {
    index: 7,
    translateLabel: 'consultation_paid',
    conditions: [gConst.STATUS_PAID],
    defaultActive: true
  },
  // 8 not show
  {
    index: 8,
    translateLabel: 'consultation_nowshow',
    conditions: [gConst.STATUS_NO_SHOW],
    defaultActive: false
  }, 
  // 9 cancel by covid
  {
    index: 9,
    translateLabel: 'consultation_canceled_by_covid',
    conditions: [gConst.STATUS_CANCELLED_FROM_COVID],
    defaultActive: false
  }
];

const allStatusTypes = {
  staff: FILTER_STATUS_ARRAY,
  radiology: FILTER_STATUS_ARRAY_RADIOLOGY,
  newJob: FILTER_STATUS_ARRAY_CREATE_NEW_JOB,
};

export const sortStatusArray = (arrayType) => {
  if (arrayType && Array.isArray(allStatusTypes[arrayType])) {
    return allStatusTypes[arrayType].sort((a, b) => a.index && b.index && a.index - b.index);
  }
  return [];
};
